<template>
 <!--скорее всего надо опцию print в mode - так можно решить отрисовку аннотированного списка и вообще норм отрисовку видов-->

 <div class="d-print-none">
  <v-btn 
    class="ml-1 my-1"
    color="regular"
    @click="$router.go(-1)">
      Go back
  </v-btn>
  <v-btn
    class="ml-1 my-1"
    color="accent"
    @click="wprint()">    
      Print in pdf
  </v-btn>
  <v-btn
    class="ml-1 my-1"
    color="vs"
    @click="dialogtips = !dialogtips">    
      How to copy as text
  </v-btn>
  </div>
  <v-dialog
v-model="dialogtips"
>

  <v-card class="rounded-0 px-1">

    Note: the print page can contain a maximum of 500 labels <br> 
<br>README START <br>
Press Ctrl+A (select all content of this page)<br>
Press Ctrl+C (copy content) <br>
Open some Word\LibreOffice template (with 2 columns or some borders etc.) <br>
Press Ctrl+V (paste content)<br>
Edit text<br>
Add enters to remove label breaks <br>
Send document to print <br>
<br>README END <br>

<div class="d-flex justify-space-between">
      <v-btn 
  class="ml-1 my-1"
      variant="flat"
      color="regular"
      @click="dialogtips = !dialogtips"
      >Close
      </v-btn>
</div>      
  </v-card>


</v-dialog>



<template v-if="this.$store.state.metaPrint.description.includes('mss_standard_print')">
  <standard-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></standard-print-page>
</template>
<!--description must be contains full word without spaces-->

<template v-else-if="this.$store.state.metaPrint.description.includes('KPABG_moss_print')">
  <kpabg-moss-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></kpabg-moss-print-page>
</template>
<template v-else-if="this.$store.state.metaPrint.description.includes('KPABG_hepatics_print')">
  <kpabg-hepatics-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></kpabg-hepatics-print-page>
</template>
<template v-else-if="this.$store.state.metaPrint.description.includes('KPABG_cyano_print')">
  <kpabg-cyano-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></kpabg-cyano-print-page>
</template>
<template v-else-if="this.$store.state.metaPrint.description.includes('live_culture_standard_print')">
  <standard-live-culture-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></standard-live-culture-print-page>
</template>
<template v-else-if="this.$store.state.metaPrint.description.includes('INEP_vascular_print')">
  <inep-vascular-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></inep-vascular-print-page>
</template>
<template v-else-if="this.$store.state.metaPrint.description.includes('lichen_species_main_print')">
  <list-standard-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></list-standard-print-page>
</template>

<template v-else-if="this.$store.state.metaPrint.description.includes('sis_standard_print')">
  <sis-standard-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></sis-standard-print-page>
</template>


<!--после перевода сосудников и грибов в sis - поделить ветвление на уровне DataPrint (DataPrint || SisDataPrint) - потому что у сисов тоже надо списки видов может будет печатать, а не только этикетки-->
<!-- <template v-if="this.$store.state.metaPrint.dataset_id == 235 || this.$store.state.metaPrint.dataset_id == 200">
  <standard-print-page v-bind="{mode:'view', meta:meta, rows:rows}"></standard-print-page>
</template> -->

<!-- <template v-if="this.$store.state.metaPrint.dataset_id == 243">
  <sis-standard-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></sis-standard-print-page>
</template>


<template v-else-if="this.$store.state.metaPrint.dataset_id == 201">
  <observation-standard-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></observation-standard-print-page>
</template>

<template v-else-if="this.$store.state.metaPrint.dataset_id == 198">
  <specieslist-standard-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></specieslist-standard-print-page>
</template>

<template v-else-if="this.$store.state.metaPrint.dataset_id == 268">
  <davydov-denis-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></davydov-denis-print-page>
</template>

-->
<template v-else>
  <default-print-page v-bind="{mode:'view', meta:this.$store.state.metaPrint, rows:this.$store.state.rowsToPrint}"></default-print-page>
</template>

                <!-- <div v-for="row in this.$store.state.rowsToPrint" :key="row">

                  <div v-for="col in this.$store.state.metaPrint.columns" :key="col">
                       <base-geo-cell v-bind="{mode:'view', column:col, meta:this.$store.state.metaPrint, rowobject:row}" v-model="row[col.fieldname]" />
                  </div>
                </div> -->

                <!-- <div class="my-2">  
        <div v-for="col in this.$store.state.metaPrint.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'view', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
        </div>
      </div>
      <div v-for="col in this.$store.state.metaPrint.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'location'" v-bind="{mode:'view', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
      </div> -->



</template>
<script>
import StandardPrintPage from '@/views/StandardPrintPage.vue';
import DefaultPrintPage from '@/views/DefaultPrintPage.vue';
import ListStandardPrintPage from '@/views/ListStandardPrintPage.vue';
import KpabgMossPrintPage from '@/views/moss/KpabgMossPrintPage.vue';
import KpabgHepaticsPrintPage from '@/views/hepatics/KpabgHepaticsPrintPage.vue';
import KpabgCyanoPrintPage from '@/views/cyano/KpabgCyanoPrintPage.vue';
import StandardLiveCulturePrintPage from '@/views/StandardLiveCulturePrintPage.vue';
import InepVascularPrintPage from '@/views/vascular/InepVascularPrintPage.vue';
//import axios from 'axios';
export default {
    name: 'data-print',
    components: {
StandardPrintPage,
DefaultPrintPage,
ListStandardPrintPage,
KpabgMossPrintPage,
KpabgHepaticsPrintPage,
KpabgCyanoPrintPage,
StandardLiveCulturePrintPage,
InepVascularPrintPage,

    },

    data(){ 
        return {
            curentRow:{},
//datameta: this.meta,
dialogtips: false,
        }
    },
//    props:['meta','rows'],
//    emits: ['getrow'],
    methods: {
      wprint(){
        window.print();
      },
    },
}
</script>